module.exports = __webpack_public_path__ + "img/electrovalence-feng@2x.ff369316.png";